export default {
  "content": "<circle cx=\"1.625\" cy=\"1\" r=\"1\" fill=\"#71777B\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "3",
    "height": "2",
    "fill": "none",
    "viewBox": "0 0 3 2"
  }
};